import axios from 'axios';
import CompanyModel from './company.model.js';

function logError(error) {
	console.log(error);
	throw error;
}

class CompaniesPageService {
	getCompaniesPageData(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/Companies?lang=${language}&populate=1`,
			)
			.then(res => res)
			.catch(logError);
	}

	getCompanies(language) {
		return axios
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}/api/collections/get/Companies?`,
				{
					lang: language,
					sort: {
						title: 1,
					},
				},
			)
			.then(({ data }) => (
				{
					data: data.entries.map(entry => new CompanyModel(entry)),
					total: data.total,
				}));
	}
}

export default new CompaniesPageService();
